export default __webpack_public_path__ + "static/media/detect.e6a1bd69.png";